module.exports = new __parcel__URL__("CantEditDark.190a22b1.svg").toString();